import { render } from "./NewCollection.vue?vue&type=template&id=13b1ac05&scoped=true"
import script from "./NewCollection.vue?vue&type=script&lang=js"
export * from "./NewCollection.vue?vue&type=script&lang=js"

import "./NewCollection.vue?vue&type=style&index=0&id=13b1ac05&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b1ac05"]])

export default __exports__